import { render, staticRenderFns } from "./AccountWorldBank.vue?vue&type=template&id=27d7c9b2&scoped=true"
import script from "./AccountWorldBank.vue?vue&type=script&lang=js"
export * from "./AccountWorldBank.vue?vue&type=script&lang=js"
import style0 from "./AccountWorldBank.vue?vue&type=style&index=0&id=27d7c9b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7c9b2",
  null
  
)

export default component.exports